import * as React from 'react';
import { ICompetitionsGrid } from './interfaces';
import { Competition } from '../Competition';
import { Grid } from '@mui/material';

export const CompetitionsGrid: React.FC<ICompetitionsGrid> = ({
  competitions,
}): JSX.Element => {
  return (
    <Grid container spacing="15px">
      {competitions.map((competition) => {
        return (
          <Grid item xs={4} key={competition.slug}>
            <Competition {...competition} />
          </Grid>
        );
      })}
    </Grid>
  );
};
